module.exports = __webpack_public_path__ + "img/deco-08.d6b81f40.png";